<template>
    <div>
        <div :class="[{ inputting: inputting }, 'form-field']">
            <select
                :id="uid"
                @blur="focused = false"
                @focus="focused = true"
                @input="$emit('input', $event.target.value)"
                @change="$emit('input', $event.target.value)"
                class="form-control form-select"
                ref="select"
                v-bind="$attrs"
            >
                <option :selected="!value" disabled value></option>
                <option
                    :selected="value != undefined && value === data"
                    :key="option"
                    :value="data"
                    v-for="(data, option) in options"
                    >{{ option }}</option
                >
            </select>
            <label @click.prevent="focus" class="form-control">{{
                label
            }}</label>
        </div>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
    name: "VSelect",
    props: {
        label: { default: "" },
        value: { default: "" },
        selectedIndex: { default: 0 },
        options: {
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            focused: false,
            uid: `select_${uniqueId()}`
        };
    },
    computed: {
        inputting() {
            return this.focused || this.value || this.value === 0;
        }
    }
};
</script>

<style lang="scss">
.was-validated .form-control:invalid {
    border-color: $danger;
    padding-right: calc(1.5em + 0.75rem);
    background-repeat: no-repeat;
    background-image: none;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid {
    border-color: rgba(0, 0, 0, 0.12);
    padding-right: calc(1.5em + 0.75rem);
    background-repeat: no-repeat;
    background-image: none;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
</style>

<style scoped lang="scss">
.form-field {
    background-color: $white;
    position: relative;
    cursor: pointer !important;
}
.form-field .form-control {
    border-radius: 0px !important;
    -webkit-appearance: none;
    -moz-appearance: none;
}
.form-control {
    background-color: $white;
    position: relative;
    cursor: text !important;
    border-radius: 0px;
    padding: 1rem 0 0.125rem 0;
    height: calc(1.5em + 1.25rem);
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background-color: transparent !important;
    cursor: text !important;

    white-space: nowrap;
    cursor: pointer !important;
}
.form-select {
    position: relative;
    z-index: 2;
    width: 100%;
    color: $dark !important;
}
.form-select:focus {
    outline: none;
    box-shadow: none;
}
.form-field label.form-control {
    color: $gray;
    position: absolute;
    top: 2px;
    left: 0;
    margin: 0px;
    display: block;
    width: 100%;
    height: 100%;
    border: none !important;
    padding: 0.375rem 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75rem;
    opacity: 0.9;
    background-color: transparent !important;
    transition: all 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
    cursor: text !important;
    z-index: 1;
}
::placeholder {
    color: transparent !important;
}
.form-field.inputting label.form-control {
    top: 1px;
    font-size: 0.75rem;
    line-height: 1rem;
    padding: 0rem 0;
    height: auto;
    color: $dark;
}
::-webkit-datetime-edit,
::-webkit-calendar-picker-indicator {
    opacity: 0;
}
.form-field.inputting ::-webkit-datetime-edit,
.form-field.inputting ::-webkit-calendar-picker-indicator {
    opacity: 1;
}

.form-field.inputting ::placeholder {
    color: $secondary !important;
    opacity: 0.4;
}
</style>
